import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import numeral from "numeral";

const style = {
  boxLabel: {
    display: "inline-block",
    marginTop: 16,
    marginLeft: 59
  },
  label: {
    height: 24,
    width: 102,
    color: "#0E283D",
    fontFamily: "Fira Sans",
    fontSize: 16,
    fontWeight: 600
  },
  trDevice: {
    display: "flex"
  },
  textPriceDevice: {
    color: "#3E3E40",
    fontFamily: "Fira Sans",
    fontSize: 13,
    marginLeft: 64
  },
  textPrice: {
    extend: "textPriceDevice",
    fontSize: 20,
    fontWeight: 600,
    textAlign: "right",
    marginLeft: 101,
    width: 194
  },
  labelPrice: {
    color: "#A7A8A8",
    fontFamily: "Fira Sans",
    fontSize: 14,
    fontWeight: 400,
    display: "block"
  },
  boxAction: {
    height: 76,
    border: "1px solid #F2F2F2",
    borderRadius: 3,
    backgroundColor: "#FFFFFF"
  }
};

const ActivationPrice = ({ classes, perdeviceActivation }) => {
  const perActivation = numeral(perdeviceActivation).format("$0,0.00");
  return (
    <div className={classes.boxAction}>
      <table className={classes.boxLabel}>
        <tbody>
          <tr className={classes.trDevice}>
            <td className={classes.label}>Activation fee</td>
            <td className={classes.textPrice}>
              {perActivation}
              <span className={classes.labelPrice}>to activate a device</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

ActivationPrice.propTypes = {
  classes: PropTypes.object.isRequired,
  perdeviceActivation: PropTypes.number.isRequired
};

export default injectSheet(style)(ActivationPrice);
